import React, { InputHTMLAttributes } from 'react'

import * as S from './styles'

interface IInputCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string
    label?: string
    classNameContainer?: string
    required?: boolean
}

const InputCheckbox: React.FC<IInputCheckboxProps> = ({
    label,
    classNameContainer = '',
    required = false,
    ...rest
}) => {
    return (
        <S.Container
            className={`input-checkbox${
                classNameContainer ? ` ${classNameContainer}` : ''
            }`}
        >
            <input {...rest} type="checkbox" />
            <span />
            {!!label && (
                <p className={`${required ? 'required' : ''}`}>{label}</p>
            )}
        </S.Container>
    )
}

export default InputCheckbox
